// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-master a {
  text-decoration: none;
}
.homecard {
  height: auto;
  width: 80%!important;
  display: flex;
  align-items: center;
  display: flex;

  justify-content: center;
  position: absolute;
}
.card {
  margin-top: 20px;
  margin-left: 50px;
  z-index: 5;
  width: 310px;
  height: 300px;
  border: 1px solid gray;
  text-align: center;
  padding: 5px;
  justify-content: space-between;
  height: 350px;
  overflow: hidden;
  flex-direction: row;
  margin-left: 10px;
  background: rgb(243, 243, 243);
  transition: transform 202ms ease-in-out;
  border: 1px solid rgba(233, 233, 233);
  border-radius: 13px;
  box-sizing: border-box;
}

.card:hover {
  cursor: pointer;
  box-shadow: -1px -1px 40px 0px rgba(0, 0, 0, 0.25);
  -webkit-box-shadow: -1px -1px 40px 0px rgba(0, 0, 0, 0.25);
  -moz-box-shadow: -1px -1px 40px 0px rgba(0, 0, 0, 0.25);
  transition: transform 02ms ease-in-out;
  transition: 300ms;
  background-color: white;
  color: black;

  z-index: 1;
  transform: skew(1deg, 0deg);
}
.product-image {
  width: 200px;
  height: auto;
}
.Title {
  color: orangered;
  text-transform: uppercase;
  text-shadow: 1px -2px 0px rgba(0, 0, 0, 0);
}
.subdata {
  padding-top: 12px;
  color: rgb(0, 0, 0);
  text-decoration: none !important;
}
.subdata:hover {
  color: black;
}
.h1-head {
  text-align: center;
  font-size: 2em;
  color:#20536F;
  margin-top: 40px;
  margin-bottom: 20px;
  text-shadow: 1px -2px 0px rgba(0, 0, 0, 0);
  font-family: "Poppins", sans-serif;
}
@media (max-width: 2560px) {
  .card-left,
  .card-right {
    /* border: 2px solid blue; */
    width: 30%;
    height: auto;
  }
  .card-left img,
  .card-right img {
    width: 50%;
    height: auto;
  }
}
@media (max-width: 1440px) {
  .card-left img,
  .card-right img {
    width: 80%;
    height: auto;
  }
}
@media (max-width: 3000px) {
  .card {
    width: 260px;
    padding: 25px;
    margin-top: 10px;
    margin-bottom: 20px;
    
  }
}
/* Responsive For Tablet Screen size 767px to 1023px START */
@media (max-width: 1023px) {
  .card {
    width: 220px;
    margin-top: 10px;
    margin-bottom: 20px;
    
  }

  .left-01,
  .left-02,
  .left-03 {
    display: flex;
    flex-direction: row;
    gap: 10px;
  }

  .mission-left,
  .mission-right {
    text-align: left;
    gap: 15px;
  }

  .left-01,
  .left-02,
  .left-03,
  .right-01,
  .right-02,
  .right-03 {
    width: 100%;
    align-items: center;
  }
  .left-01 p,
  .left-01 h3 {
    padding-left: 10px;
  }
}

/* Responsive For Tablet Screen size 601px to 1023px END */

/* Responsive For Mobile Screen size 1024px to 1920px START */
@media (max-width: 767px) {
  .card {
    width: 320px;
    margin-left: 50px;
  }

  .card-left img,
  .card-right img {
    width: 60%;
    height: auto;
  }

  .card-master {
    display: flex;
    flex-direction: column;
    top: 450px;
    gap: 50px;
  }
}

/* Responsive For Mobile Screen size 1024px to 1920px END */
`, "",{"version":3,"sources":["webpack://./src/Components/HomecardStyles.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,aAAa;;EAEb,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,8BAA8B;EAC9B,uCAAuC;EACvC,qCAAqC;EACrC,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kDAAkD;EAClD,0DAA0D;EAC1D,uDAAuD;EACvD,sCAAsC;EACtC,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;;EAEZ,UAAU;EACV,2BAA2B;AAC7B;AACA;EACE,YAAY;EACZ,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,0CAA0C;AAC5C;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,0CAA0C;EAC1C,kCAAkC;AACpC;AACA;EACE;;IAEE,4BAA4B;IAC5B,UAAU;IACV,YAAY;EACd;EACA;;IAEE,UAAU;IACV,YAAY;EACd;AACF;AACA;EACE;;IAEE,UAAU;IACV,YAAY;EACd;AACF;AACA;EACE;IACE,YAAY;IACZ,aAAa;IACb,gBAAgB;IAChB,mBAAmB;;EAErB;AACF;AACA,4DAA4D;AAC5D;EACE;IACE,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;;EAErB;;EAEA;;;IAGE,aAAa;IACb,mBAAmB;IACnB,SAAS;EACX;;EAEA;;IAEE,gBAAgB;IAChB,SAAS;EACX;;EAEA;;;;;;IAME,WAAW;IACX,mBAAmB;EACrB;EACA;;IAEE,kBAAkB;EACpB;AACF;;AAEA,0DAA0D;;AAE1D,6DAA6D;AAC7D;EACE;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;;IAEE,UAAU;IACV,YAAY;EACd;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,SAAS;EACX;AACF;;AAEA,2DAA2D","sourcesContent":[".card-master a {\n  text-decoration: none;\n}\n.homecard {\n  height: auto;\n  width: 80%!important;\n  display: flex;\n  align-items: center;\n  display: flex;\n\n  justify-content: center;\n  position: absolute;\n}\n.card {\n  margin-top: 20px;\n  margin-left: 50px;\n  z-index: 5;\n  width: 310px;\n  height: 300px;\n  border: 1px solid gray;\n  text-align: center;\n  padding: 5px;\n  justify-content: space-between;\n  height: 350px;\n  overflow: hidden;\n  flex-direction: row;\n  margin-left: 10px;\n  background: rgb(243, 243, 243);\n  transition: transform 202ms ease-in-out;\n  border: 1px solid rgba(233, 233, 233);\n  border-radius: 13px;\n  box-sizing: border-box;\n}\n\n.card:hover {\n  cursor: pointer;\n  box-shadow: -1px -1px 40px 0px rgba(0, 0, 0, 0.25);\n  -webkit-box-shadow: -1px -1px 40px 0px rgba(0, 0, 0, 0.25);\n  -moz-box-shadow: -1px -1px 40px 0px rgba(0, 0, 0, 0.25);\n  transition: transform 02ms ease-in-out;\n  transition: 300ms;\n  background-color: white;\n  color: black;\n\n  z-index: 1;\n  transform: skew(1deg, 0deg);\n}\n.product-image {\n  width: 200px;\n  height: auto;\n}\n.Title {\n  color: orangered;\n  text-transform: uppercase;\n  text-shadow: 1px -2px 0px rgba(0, 0, 0, 0);\n}\n.subdata {\n  padding-top: 12px;\n  color: rgb(0, 0, 0);\n  text-decoration: none !important;\n}\n.subdata:hover {\n  color: black;\n}\n.h1-head {\n  text-align: center;\n  font-size: 2em;\n  color:#20536F;\n  margin-top: 40px;\n  margin-bottom: 20px;\n  text-shadow: 1px -2px 0px rgba(0, 0, 0, 0);\n  font-family: \"Poppins\", sans-serif;\n}\n@media (max-width: 2560px) {\n  .card-left,\n  .card-right {\n    /* border: 2px solid blue; */\n    width: 30%;\n    height: auto;\n  }\n  .card-left img,\n  .card-right img {\n    width: 50%;\n    height: auto;\n  }\n}\n@media (max-width: 1440px) {\n  .card-left img,\n  .card-right img {\n    width: 80%;\n    height: auto;\n  }\n}\n@media (max-width: 3000px) {\n  .card {\n    width: 260px;\n    padding: 25px;\n    margin-top: 10px;\n    margin-bottom: 20px;\n    \n  }\n}\n/* Responsive For Tablet Screen size 767px to 1023px START */\n@media (max-width: 1023px) {\n  .card {\n    width: 220px;\n    margin-top: 10px;\n    margin-bottom: 20px;\n    \n  }\n\n  .left-01,\n  .left-02,\n  .left-03 {\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n  }\n\n  .mission-left,\n  .mission-right {\n    text-align: left;\n    gap: 15px;\n  }\n\n  .left-01,\n  .left-02,\n  .left-03,\n  .right-01,\n  .right-02,\n  .right-03 {\n    width: 100%;\n    align-items: center;\n  }\n  .left-01 p,\n  .left-01 h3 {\n    padding-left: 10px;\n  }\n}\n\n/* Responsive For Tablet Screen size 601px to 1023px END */\n\n/* Responsive For Mobile Screen size 1024px to 1920px START */\n@media (max-width: 767px) {\n  .card {\n    width: 320px;\n    margin-left: 50px;\n  }\n\n  .card-left img,\n  .card-right img {\n    width: 60%;\n    height: auto;\n  }\n\n  .card-master {\n    display: flex;\n    flex-direction: column;\n    top: 450px;\n    gap: 50px;\n  }\n}\n\n/* Responsive For Mobile Screen size 1024px to 1920px END */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
